/** Core Model types */
export interface Institute {
  id: number;
  name: string;
  headOfInstitute: string;
  city: string;
  zip: string;
  street: string;
  housenumber: string;
  additionalAddress: string;
  country: string;
  phone: string;
  email: string;
  fax: string;
  hospitalName: string;
  isCompany: boolean;
  instituteID: string;
  taxID: string;
  invoiceName: string;
  invoiceCity: string;
  invoiceZip: string;
  invoiceStreet: string;
  invoiceHousenumber: string;
  invoiceCountry: string;
  certificationName: string;
  certificationCity: string;
  certificationZip: string;
  certificationStreet: string;
  certificationHousenumber: string;
  certificationCountry: string;
  forwardAddresses?: string[];
  geoCoordinates: GeoCoordinates;
  customClearanceUser?: string;
  customClearanceContact?: string;
  customClearanceEmail?: string;
  eoriNumber?: string;
  pendingApproval?: boolean;
  comments: string;
}

interface GeoCoordinates {
  id: string;
  type: string;
  // eslint-disable-next-line camelcase
  place_type: string[];
  relevance: number;
  properties: GeoProperties;
  text: string;
  // eslint-disable-next-line camelcase
  place_name: string;
  // eslint-disable-next-line camelcase
  matching_place_name: string;
  center: number[];
  geometry: GeoGeometry;
  address: string;
  context: GeoContext;
}

interface GeoProperties {
  description: string;
  address: string;
}

interface GeoGeometry {
  type: string;
  coordinates: number[];
}

interface GeoContext {
  id: string;
  text: string;
  wikidata?: string;
  // eslint-disable-next-line camelcase
  short_code?: string;
}

export type InstituteById = {
  [key: number]: Institute;
}

/** Redux initial state */
export interface InstituteState {
  selectedInstituteIds: string[] | number[];
  byId?: InstituteById;
  allIds?: number[]
}

/** Redux action constants */

export const SET_SELECTED_INSTITUTE_IDS = 'SET_SELECTED_INSTITUTE_IDS';
export const SET_INSTITUTES = 'SET_INSTITUTES';
export const UPDATE_INSTITUTE = 'UPDATE_INSTITUTE';
export const ADD_INSTITUTE = 'ADD_INSTITUTE';
export const DELETE_INSTITUTE = 'DELETE_INSTITUTE';

/** Action types */

type SetSelectedInstituteIds = {
  type: typeof SET_SELECTED_INSTITUTE_IDS;
  payload: number[] | string[];
};

type setInstitutes = {
  type: typeof SET_INSTITUTES;
  payload: Institute[];
}

type updateInstitute = {
  type: typeof UPDATE_INSTITUTE;
  payload: Institute;
}

type addInstitute = {
  type: typeof ADD_INSTITUTE;
  payload: Institute;
}

type deleteInstitute = {
  type: typeof DELETE_INSTITUTE;
  payload: number;
}

export type InstituteActionTypes = SetSelectedInstituteIds | setInstitutes
| updateInstitute | addInstitute | deleteInstitute;
